import {
  Box,
  Button,
  ButtonGroup,
  Card,
  CardContent,
  CheckerBoard,
  ConjoinedIcons,
  Image,
  Text,
  Tooltip,
} from "@prismicio/editor-ui"
import { type PropsWithChildren, useState } from "react"

export interface LinkImageCardProps {
  url: string
  title: string
  subTitle: string
  onEdit?: () => void
  onUnlink?: () => void
}

export function LinkImageCard(props: LinkImageCardProps) {
  const { onEdit, onUnlink, url, title, subTitle } = props
  const [container, setContainer] = useState<Element | null>(null)

  return (
    <Card paddingBlock={16} ref={setContainer}>
      <CardContent>
        <LinkImageCardHeader
          url={url}
          title={title}
          subTitle={subTitle}
          onEdit={onEdit}
          onUnlink={onUnlink}
          container={container}
        />

        {url && (
          <CheckerBoard>
            <ImageContainer>
              <Image src={url} alt={title} sizing="contain" />
            </ImageContainer>
          </CheckerBoard>
        )}
      </CardContent>
    </Card>
  )
}

function ImageContainer(props: PropsWithChildren) {
  const { children } = props

  return (
    <Box
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      position="relative"
      height={327}
    >
      {children}
    </Box>
  )
}

interface LinkImageCardHeaderProps extends LinkImageCardProps {
  container: Element | null
}

function LinkImageCardHeader(props: LinkImageCardHeaderProps) {
  const { url, title, subTitle, onEdit, onUnlink, container } = props

  return (
    <Box flexDirection="row" justifyContent="space-between" gap={8}>
      <Box gap={8} minWidth={0}>
        <ConjoinedIcons largeIconName="image" smallIconName="link" />
        <Box flexDirection="column" minWidth={0}>
          <Text noWrap variant="smallBold" href={url} inline>
            {title}
          </Text>
          <Text variant="small" color="grey11">
            {subTitle}
          </Text>
        </Box>
      </Box>
      <ButtonGroup size="medium" color="grey">
        {onEdit && (
          <Tooltip content="Edit link" side="top" container={container}>
            <Button startIcon="edit" onClick={onEdit} />
          </Tooltip>
        )}
        {onUnlink && (
          <Tooltip content="Remove link" side="top" container={container}>
            <Button startIcon="linkOff" onClick={onUnlink} />
          </Tooltip>
        )}
      </ButtonGroup>
    </Box>
  )
}
